import React from "react";

const Footer = () => {
  return (
    <div>
      <div id="footer-fixed" className="footer black-bg">
        <div className="page-section-pt">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 sm-mb-30">
                <div className="footer-logo">
                  <img
                    id="logo_img"
                    src="/assets/images/logos/logo1.png"
                    alt="logo"
                    style={{ width: "122px", height: "90px" }}
                  />
                  <p className="pb-10">
                    {" "}
                    Depuis 1966 SACEM Industries est le leader dans la
                    fabrication et la commercialisation des transformateurs de
                    distribution électriques monophasés, triphasés et
                    spéciaux...
                  </p>
                </div>
                <div className="social-icons color-hover">
                  <ul>
                    <li className="social-facebook">
                      <a
                        href="https://www.facebook.com/sacemindustries/?locale=fr_FR"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li className="social-linkedin">
                      <a
                        href="https://fr.linkedin.com/company/sacem-group"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin" />{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-6 sm-mb-30">
                <div className="footer-useful-link footer-hedding">
                  <h6 className="text-white mb-30 mt-10 text-uppercase">
                    Navigation
                  </h6>
                  <ul>
                    <li>
                      <a href="/">Accueil</a>
                    </li>
                    <li>
                      <a href="/services">Services</a>
                    </li>
                    <li>
                      <a href="/produits">Produits</a>
                    </li>

                    <li>
                      <a href="/nouscontacter">Nous Contacter</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-6 xs-mb-30">
                <div className="footer-useful-link footer-hedding">
                  <h6 className="text-white mb-30 mt-10 text-uppercase">
                    Liens utiles
                  </h6>
                  <ul>
                    <li>
                      <a href="actualites">Actualités</a>
                    </li>
                    <li>
                      <a href="/carrieres">Carriéres</a>
                    </li>
                    <li>
                      {" "}
                      <a href="/faqs">FAQ</a>
                    </li>
                    <li>
                      {" "}
                      <a href="/privacy-policy">Politique de Confidentialité</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <h6 className="text-white mb-30 mt-10 text-uppercase">
                  NOUS CONTACTER
                </h6>
                <ul className="addresss-info">
                  <li>
                    <i className="fa fa-map-marker" />{" "}
                    <p>
                      Siège :Imm. Mak Crown, 3ème étage, Rue du Lac Tanganyika
                      Les Berges du Lac 1053 Tunis, Tunisie
                    </p>{" "}
                  </li>
                  <li>
                    <i className="fa fa-map-marker" />{" "}
                    <p>
                      USINE :Zone industrielle Sidi Rézig Tinja - 7032 Menzel
                      Bourguiba, Tunisie
                    </p>{" "}
                  </li>
                  <li>
                    <i className="fa fa-phone" />{" "}
                    <a href="tel:0021671966986">
                      {" "}
                      <span>+(216) 71 966 986 </span>{" "}
                    </a>{" "}
                  </li>
                  <li>
                    <i className="fa fa-envelope-o" />
                    <a href="mailto:contact@sacemgroup.com">
                      contact@sacemgroup.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-widget mt-20">
              <div className="row">
                <div className="col-md-12 text-center">
                  <p className="mt-15">
                    {" "}
                    © 2026 <span id="copyright"> </span>{" "}
                    <a href="/"> SACEM GROUP </a> All Rights Reserved{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
